import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=4c5ec8fd&"
import script from "./CustomerModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5ec8fd')) {
      api.createRecord('4c5ec8fd', component.options)
    } else {
      api.reload('4c5ec8fd', component.options)
    }
    module.hot.accept("./CustomerModal.vue?vue&type=template&id=4c5ec8fd&", function () {
      api.rerender('4c5ec8fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/CustomerModal.vue"
export default component.exports